import { useState } from "react";
import axios from "axios";

export default function HeroAvailability() {
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [roomId, setRoomId] = useState("1");
  const [adult, setAdult] = useState("1");
  const [children, setChildren] = useState("0");
  const [loading, setLoading] = useState(false);

  const checkAvailability = async () => {
    if (!checkIn || !checkOut) {
      alert("Please select check-in and check-out dates");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        "http://localhost:8080/api/booking/check",
        {
          roomId: Number(roomId),
          checkIn,
          checkOut
        }
      );

      if (res.data === true) {
        alert("✅ Room is available");
      } else {
        alert("❌ Room not available");
      }
    } catch (err) {
      alert("Error checking availability");
    } finally {
      setLoading(false);
    }
  };

  return (
    // <div className="booking-area">
    //   {/* Check In */}
    //   <input
    //     type="date"
    //     onChange={(e) => setCheckIn(e.target.value)}
    //   />

    //   {/* Check Out */}
    //   <input
    //     type="date"
    //     onChange={(e) => setCheckOut(e.target.value)}
    //   />

    //   {/* Room */}
    //   <select onChange={(e) => setRoomId(e.target.value)}>
    //     <option value="1">01</option>
    //     <option value="2">02</option>
    //     <option value="3">03</option>
    //   </select>

    //   {/* Adult */}
    //   <select onChange={(e) => setAdult(e.target.value)}>
    //     <option>01</option>
    //     <option>02</option>
    //   </select>

    //   {/* Children */}
    //   <select onChange={(e) => setChildren(e.target.value)}>
    //     <option>00</option>
    //     <option>01</option>
    //   </select>

    //   {/* Button */}
    //   <button onClick={checkAvailability} disabled={loading}>
    //     {loading ? "Checking..." : "Check Availability"}
    //   </button>
    // </div>



<div className="hero-fresh d-flex align-items-center justify-content-center">
  
  {/* HERO TEXT */}
  <div
    className="container text-center text-white position-relative"
    style={{ zIndex: 2 }}
  >
    <p className="text-uppercase mb-2 tracking-widest fw-light">
      Hotel & Resort
    </p>
    <h1 className="display-1 fw-bold mb-4">
      Welcome To NIVARA AGRO TOURISM
    </h1>
    <button className="btn btn-outline-light rounded-0 px-5 py-3 fw-bold tracking-widest">
      DISCOVER NOW
    </button>
  </div>

  {/* FLOATING AVAILABILITY FORM */}
  <div className="container availability-wrapper d-none d-lg-block">
    <div className="card border-0 shadow-lg p-4">
      <form className="row g-3 align-items-end">

        <div className="col">
          <label className="form-label small fw-bold">Check In</label>
          <input
            type="date"
            className="form-control bg-light border-0"
            onChange={(e) => setCheckIn(e.target.value)}
          />
        </div>

        <div className="col">
          <label className="form-label small fw-bold">Check Out</label>
          <input
            type="date"
            className="form-control bg-light border-0"
            onChange={(e) => setCheckOut(e.target.value)}
          />
        </div>

        <div className="col-1">
          <label className="form-label small fw-bold">Room</label>
          <select
            className="form-select bg-light border-0"
            onChange={(e) => setRoomId(e.target.value)}
          >
            <option value="1">01</option>
            <option value="2">02</option>
            <option value="3">03</option>
            <option value="4">04</option>
          </select>
        </div>

        <div className="col-1">
          <label className="form-label small fw-bold">Adult</label>
          <select
            className="form-select bg-light border-0"
            onChange={(e) => setAdult(e.target.value)}
          >
            <option value="1">01</option>
            <option value="2">02</option>
            <option value="3">03</option>
            <option value="4">04</option>
          </select>
        </div>

        <div className="col-1">
          <label className="form-label small fw-bold">Children</label>
          <select
            className="form-select bg-light border-0"
            onChange={(e) => setChildren(e.target.value)}
          >
            <option value="0">00</option>
            <option value="1">01</option>
            <option value="2">02</option>
            <option value="3">03</option>
            <option value="4">04</option>
          </select>
        </div>

        <div className="col-md-3">
          <button
            type="button"
            className="btn btn-roberto w-100 py-3 text-black fw-bold"
            onClick={checkAvailability}
            disabled={loading}
          >
            {loading ? "Checking..." : "Check Availability"}
          </button>
        </div>

      </form>
    </div>
  </div>
</div>












  );
}
